import React from 'react'
import InterpreterForm from './InterpreterForm'
import { useNavigate, useParams } from 'react-router-dom';

const InterpreterEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  
  return (
    <div className='content'>
      <div className="row_main_head">
          <div className='d-flex align-items-center gap-2'>
              <button className="main_heading back_button" onClick={() => navigate(-1)}>
                  <i className="fa-solid fa-arrow-left"></i> Back
              </button>
              <h2 className={`main_heading`}>Edit Interpreter</h2>
          </div>
          {/* <LiveClock /> */}
      </div>
      <InterpreterForm interpreterId={id}/>
    </div>
  )
}

export default InterpreterEdit;
